import styled from 'styled-components';
import { Divider as MUIDivider, Theme } from '@material-ui/core';

const theme = (props: any) => {
  return props.theme as Theme;
}

export const Divider = styled(MUIDivider)(props => ({
  
})) as typeof MUIDivider;